<template>
  <article>
   <div class="filter mt-20 mb-20">
      <div class="ml-auto">
        <button class="blue-small-btn" @click="initEdit">新建</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700">
      <el-table-column prop="opid" label="运营ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="username" label="姓名" width="" align="center">
      </el-table-column>
      <el-table-column prop="nickname" label="昵称" width="" align="center">
      </el-table-column>
      <el-table-column prop="account" label="账号" width="" align="center">
      </el-table-column>
      <el-table-column prop="mobile" label="手机号码" width="" align="center">
      </el-table-column>
      <el-table-column prop="uid" label="用户ID" width="" align="center">
      </el-table-column>
      <el-table-column prop="bank" label="银行卡" width="" align="center">
      </el-table-column>
      <el-table-column prop="alipay" label="支付宝收款码" width="" align="center">
        <template slot-scope="scope">
          <div class="mt10">
            <img :src="scope.row.alipay" height="40px" weight="30px" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="wechat" label="微信名收款码" width="" align="center">
        <template slot-scope="scope">
          <div class="mt10">
            <img :src="scope.row.wechat" height="40px" weight="30px" />
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="角色" width="" align="center">
        <template slot-scope="scope">
          <div v-for="item in scope.row.roles">
            <div>{{item.role_name}}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="" label="状态" width="" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.status == 1" class="normal-btn">正常</div>
          <div v-if="scope.row.status == 0" class="danger-btn">失效</div>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="editDetail(scope.$index)">编辑</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="分类编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">账单ID</div>
            <el-input v-model="detail.opid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">姓名</div>
            <el-input v-model="detail.username" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">昵称</div>
            <el-input v-model="detail.nickname" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">账号</div>
            <el-input v-model="detail.account" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20" v-if="detail.opid === 0">
            <div class="dataForm__name">密码</div>
            <el-input v-model="detail.password" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">手机号码</div>
            <el-input v-model="detail.mobile" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">银行卡</div>
            <el-input type="textarea" :rows="2" v-model="detail.bank" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">支付宝收款码:</div>
            <uploadHeadImage :url.sync="detail.alipay" :itype="5"></uploadHeadImage>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">微信收款码:</div>
            <uploadHeadImage :url.sync="detail.wechat" :itype="5"></uploadHeadImage>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">角色:</div>
            <el-checkbox-group v-model="detail.roles">
              <el-checkbox v-for="item in roleLists" :label="item.roid" :key="item.roid">{{item.role_name}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">状态</div>
            <el-radio-group v-model="detail.status">
              <div class="dib mr-20">
                <el-radio :label="0">失效</el-radio>
                <el-radio :label="1">正常</el-radio>
              </div>
            </el-radio-group>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="operEdit">保存</div>
          <div class="gray-large-btn" @click="detailDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import util from '../../script/util'
import {requestData} from '../../script/request'
import {operLists, operEdit} from '../../api/api'
import uploadHeadImage from '../../components/uploadImage.vue'
export default {
  name: 'oper',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      lists: [],
      listLoading: false,
      detailDialog: false,
      roleLists: [],
      detail: {
        opid: 0,
        username: '',
        nickname: '',
        account: '',
        password: '',
        mobile: '',
        bank: '',
        alipay: '',
        wechat: '',
        roles: [],
        status: 1
      }
    }
  },
  methods: {
    initEdit () {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = ''
      }
      this.detail.roles = []
      this.detail.status = 1
      this.detail.opid = 0
    },
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }

      // 提取所有 roid
      this.detail.roles = this.lists[index]['roles'].map(item => item.roid)
    },
    operEdit () {
      let params = util.cloneObj(this.detail)

      // 格式化
      params['roles'] = JSON.stringify({'lists': this.detail.roles})

      operEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.detailDialog = false
          this.getList()

          for (let key in this.detail) {
            this.detail[key] = ''
          }
          this.detail.opid = 0
          this.detail.weight = 0
          this.detail.status = 1
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    async getOperRoleList () {
      const params = {} // 只传 params

      const result = await requestData('operRoleLists', params)

      if (result) {
        this.roleLists = result.lists
      }
    },
    getList () {
      let params = {
      }

      this.listLoading = true
      operLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()

    this.getOperRoleList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/manage/operList.vue